export default "__VITE_ASSET__Dd5m01Rp__"